import { FC } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { InsertDriveFile } from '@mui/icons-material';
import { FileInfo } from '../../types';
import FileRowActions from './FileRowActions';
import RenameForm from './RenameForm';

interface FileTableProps {
  files: FileInfo[];
  editingFileId: number | null;
  editedFilename: string;
  renameError: string | null;
  isRenamePending: boolean;
  isDeletePending: boolean;
  isDownloadingId: number | null;
  isViewer: boolean;
  onFilenameChange: (value: string) => void;
  onConfirmRename: () => void;
  onCancelRename: () => void;
  onStartRename: (file: FileInfo) => void;
  onViewDashboard: (fileId: number) => void;
  onDownload: (fileId: number, filename: string) => void;
  onOpenDeleteDialog: (fileId: number) => void;
  formatDate: (date: string) => string;
}

const FileTable: FC<FileTableProps> = ({
  files,
  editingFileId,
  editedFilename,
  renameError,
  isRenamePending,
  isDeletePending,
  isDownloadingId,
  isViewer,
  onFilenameChange,
  onConfirmRename,
  onCancelRename,
  onStartRename,
  onViewDashboard,
  onDownload,
  onOpenDeleteDialog,
  formatDate,
}) => (
  <TableContainer>
    <Table sx={{ minWidth: 800 }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ minWidth: 300, fontWeight: 'bold' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <InsertDriveFile sx={{ mr: 1, color: 'text.secondary' }} />
              ファイル名
            </Box>
          </TableCell>
          <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
            アップロード日時
          </TableCell>
          <TableCell align="center" sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
            操作
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {files.map((file) => {
          const isEditing = editingFileId === file.id;
          const isDownloading = isDownloadingId === file.id;
          return (
            <TableRow key={file.id} hover>
              <TableCell sx={{ wordBreak: 'break-all' }}>
                {isEditing ? (
                  <RenameForm
                    value={editedFilename}
                    error={renameError}
                    isPending={isRenamePending}
                    onChange={onFilenameChange}
                    onConfirm={onConfirmRename}
                    onCancel={onCancelRename}
                  />
                ) : (
                  file.filename
                )}
              </TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {formatDate(file.created_at)}
              </TableCell>
              <TableCell align="center">
                <FileRowActions
                  isEditing={isEditing}
                  isDownloading={isDownloading}
                  isRenamePending={isRenamePending}
                  isDeletePending={isDeletePending}
                  isViewer={isViewer}
                  onViewDashboard={() => onViewDashboard(file.id)}
                  onStartRename={() => onStartRename(file)}
                  onDownload={() => onDownload(file.id, file.filename)}
                  onOpenDeleteDialog={() => onOpenDeleteDialog(file.id)}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

export default FileTable;
